// src/features/urlaubsplaner/types/index.ts

export type AbwesenheitsArt = 'urlaub' | 'sonstige_abwesenheit';

export interface StaffUrlaub {
  id: string;
  staff_id: string;
  von: string; // ISO date string (YYYY-MM-DD)
  bis: string; // ISO date string (YYYY-MM-DD)
  art: AbwesenheitsArt;
  ist_halber_tag?: boolean;
  notiz?: string;
  created_at?: string;
  updated_at?: string;
}

export interface StaffUrlaubMitName extends StaffUrlaub {
  staff_name: string;
  staff_initials: string;
}

export interface UrlaubFormData {
  staff_id: string;
  von: string;
  bis: string;
  art: AbwesenheitsArt;
  ist_halber_tag: boolean;
  notiz: string;
}

export const ABWESENHEITS_ARTEN: Record<AbwesenheitsArt, string> = {
  urlaub: 'Urlaub',
  sonstige_abwesenheit: 'Sonstige Abwesenheit'
};

export const ABWESENHEITS_FARBEN: Record<AbwesenheitsArt, string> = {
  urlaub: '#3B82F6',
  sonstige_abwesenheit: '#F59E0B'
};
